import Immutable from 'immutable';
import {
  CARGO_CORPORATE_CREDIT_PATH,
  CORPORATE_UNIT_PATH,
  HOME_PATH,
  MANUAL_VOUCHER_PAYMENT_PATH,
  TICKET_CORPORATE_CREDIT_PATH,
} from '../../../config/paths';

const INITIAL_STATE = Immutable.Map({
  cards: [
    {
      key: 'cargo-corporate-credit',
      title: 'Crédito Corporativo de Carga',
      path: CARGO_CORPORATE_CREDIT_PATH,
      icon: 'credit-card',
    },
    {
      key: 'ticket-corporate-credit',
      title: 'Crédito Corporativo de Pasajes',
      path: TICKET_CORPORATE_CREDIT_PATH,
      icon: 'ticket',
    },
    {
      key: 'manual-voucher-payment',
      title: 'Pago de Credito Corporativos',
      path: MANUAL_VOUCHER_PAYMENT_PATH,
      icon: 'usd',
    },
  ],
  breadcrumbs: [
    {
      text: 'Inicio',
      tag: 'a',
      href: HOME_PATH,
    },
    {
      text: 'Ventas Corporativas',
      tag: 'span',
      href: CORPORATE_UNIT_PATH,
    },
  ],
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
